"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _constants = require("composer-lib/lib/constants");

// "Dumb" check to see if string might be JSON
function isJSON(subject) {
  return subject.indexOf('{') > -1 && subject.indexOf('}') > -1 || subject.indexOf('[') > -1 && subject.indexOf(']') > -1;
}

function safeParseJSON(maybeJson) {
  var result = maybeJson;

  if (isJSON(maybeJson)) {
    try {
      result = JSON.parse(maybeJson);
    } catch (e) {// empty (linter complains otherwise)
    }
  }

  return result;
}

function parseUserAttributes(data) {
  return data.attributes.reduce(function (acc, attr) {
    return acc.set(attr.key, safeParseJSON(attr.value));
  }, new _immutable.Map());
}

var DEFAULTS = {
  status: _constants.RequestStatus.UNINITIALIZED,
  data: new _immutable.Map()
};

var UserAttributes = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(UserAttributes, _Record);

  function UserAttributes() {
    (0, _classCallCheck2.default)(this, UserAttributes);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UserAttributes).apply(this, arguments));
  }

  (0, _createClass2.default)(UserAttributes, null, [{
    key: "fromJS",
    value: function fromJS(data) {
      return new UserAttributes({
        data: parseUserAttributes(data),
        status: _constants.RequestStatus.SUCCEEDED
      });
    }
  }, {
    key: "prepareAttributeValue",
    value: function prepareAttributeValue(value) {
      return safeParseJSON(value);
    }
  }]);
  return UserAttributes;
}((0, _immutable.Record)(DEFAULTS));

exports.default = UserAttributes;
module.exports = exports.default;